import {ReactElement, ReactNode} from 'react';

const dateFormatter = new Intl.DateTimeFormat(undefined, {
	dateStyle: 'long'
});

const timeFormatter = new Intl.DateTimeFormat(undefined, {
	timeStyle: 'short',
});

const fullFormatter = new Intl.DateTimeFormat(undefined, {
	dateStyle: 'short',
	timeStyle: 'short',
});

interface Props {
	date: Date,
	format?: 'date' | 'time' | 'full',
}

export default function Date({date, format = 'full'}: Props): ReactNode {
	switch (format) {
		case 'date':
			return dateFormatter.format(date);

		case 'time':
			return timeFormatter.format(date);

		case 'full':
			return fullFormatter.format(date);

		default:
			throw new Error(`Unrecognized format name "${format}"`);
	}
}
